module.exports = __webpack_public_path__ + "static/media/join-us-img.2f20e0d9.png";